<template>
  <div>
    <div class="header-sticky"><resend-bar /> <Header /></div>
    <div>
      <div class="header-banner">
        <div class="text-wrapper">
          <p class="m-0 title">CONTACT US</p>
          <p class="title-text-element">
            If you have some ideas or want to see a new feature on the MyCircles platform, please send us a message.
          </p>
          <p class="title-text-element ">
            Also, if something’s broken, or the user experience can be improved, please contact us and tell us how can we get better.
          </p>
        </div>
      </div>
      <div class="contact-form my-5">
        <div class="row mt-3">
          <div class="w-100 text-left">
            <label for="f_name" class="mb-1 input-label">First Name</label>
            <a-input :size="'large'" placeholder="Provide first name" v-model="$v.formData.first_name.$model" />
            <div class="error-container" v-if="$v.formData.first_name.$error">
              <div class="error-item" v-if="!$v.formData.first_name.required">
                First Name is required
              </div>
              <div class="error-item" v-if="!$v.formData.first_name.alpha">
                Enter only alphabets
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="w-100 text-left">
            <label for="f_name" class="mb-1 input-label">Last Name</label>
            <a-input :size="'large'" placeholder="Provide last name" v-model="$v.formData.last_name.$model" />
            <div class="error-container" v-if="$v.formData.last_name.$error">
              <div class="error-item" v-if="!$v.formData.last_name.required">
                Last Name is required
              </div>
              <div class="error-item" v-if="!$v.formData.last_name.alpha">
                Enter only alphabets
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="w-100 text-left">
            <label for="l_name" class="mb-1 input-label">Email Address</label>
            <a-input :size="'large'" placeholder="Provide email" v-model="$v.formData.email.$model" />
            <div class="error-container" v-if="$v.formData.email.$error">
              <div class="error-item" v-if="!$v.formData.email.required">
                Email is required
              </div>
              <div class="error-item" v-if="!$v.formData.email.email">
                Invalid email address
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="w-100 text-left">
            <label for="email" class="mb-1 input-label">Message</label>
            <a-textarea :size="'large'" placeholder="Provide message" v-model="$v.formData.message.$model" />
            <div class="error-container" v-if="$v.formData.message.$error">
              <div class="error-item" v-if="!$v.formData.message.required">
                Message is required
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <a-button :loading="loading" @click="send" class="mx-auto dovemed-button font-white primary-button" :style="{ background: getPrimaryFallbackColor() }">SEND </a-button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./HeaderGeneric"
import Footer from "./FooterGeneric"
import ResendBar from "./resendBar.vue"
import { required, email, alpha } from "vuelidate/lib/validators"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"

const AppRepository = RepositoryFactory.get("app")

export default {
  name: "ContactUsPage",
  components: {
    Header,
    Footer,
    ResendBar,
  },

  data() {
    return {
      formData: {
        first_name: null,
        last_name: null,
        email: null,
        message: null,
      },
      loading: false,
    }
  },

  created() {
    console.warn("ContactUs.vue is created")
  },

  validations: {
    formData: {
      first_name: {
        required,
        alpha,
      },
      last_name: {
        required,
        alpha,
      },
      email: {
        required,
        email,
      },
      message: {
        required,
      },
    },
  },

  methods: {
    send() {
      this.$v.formData.$touch()
      if (!this.$v.formData.$anyError) {
        this.loading = true
        const payload = {
          first_name: this.formData.first_name,
          last_name: this.formData.last_name,
          email: this.formData.email,
          message: this.formData.message,
        }
        AppRepository.contactForm(payload)
          .then(res => {
            this.$notification.success({ message: "Success", description: "Thanks for contacting us! We will get back to you shortly." })
            this.formData.first_name = null
            this.formData.last_name = null
            this.formData.email = null
            this.formData.message = null
            this.$v.$reset()
            this.loading = false
          })
          .catch(err => {
            this.loading = false
            this.$notification.success({
              message: "Error",
              description: `${err}`,
            })
          })
      }
    },
  },
}
</script>

<style scoped>
.title-text-element {
  color: #ffffff !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;

  @media screen and (max-width: 580px) {
    font-size: 24px;
  }
}
.title-text-element:not(:last-child) {
  padding-top: 18px;
}

.input-label {
  font-weight: 700;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/App/ContactUs.vue